import { useEffect, useRef, useState } from "react";
import { motion, useInView, animate } from "framer-motion";
import { METRICS } from "../data/content";
import { MaskedLines } from "./Reveal";

const Counter = ({ value, decimals = 0, prefix = "", suffix = "" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });
  const [display, setDisplay] = useState("0");

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, value, {
      duration: 2.1,
      ease: [0.16, 1, 0.3, 1],
      onUpdate: (v) => setDisplay(v.toFixed(decimals)),
    });
    return () => controls.stop();
  }, [inView, value, decimals]);

  return (
    <span ref={ref}>
      {prefix}
      {display}
      {suffix}
    </span>
  );
};

export const ImpactDashboard = () => (
  <section id="impact" data-testid="impact-dashboard" className="spotlight relative overflow-hidden py-24 md:py-36">
    <div className="mx-auto max-w-7xl px-6 md:px-10">
      <p className="text-xs font-bold uppercase tracking-[0.32em] text-[#00BFA5]">The Numbers</p>
      <h2 className="mt-5 font-display text-4xl font-black tracking-tight text-[#0A192F] md:text-6xl">
        <MaskedLines lines={["My Impact Dashboard"]} />
      </h2>

      <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {METRICS.map((m, i) => (
          <motion.div
            key={m.label}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: (i % 4) * 0.1 }}
            whileHover={{ y: -6 }}
            className={`glass rounded-3xl p-7 ${i === 0 || i === 2 ? "lg:col-span-2" : ""}`}
            data-testid={`metric-${i}`}
          >
            <p className="font-display text-4xl font-black tracking-tight text-[#0A192F] md:text-5xl">
              <Counter value={m.value} decimals={m.decimals || 0} prefix={m.prefix || ""} suffix={m.suffix || ""} />
            </p>
            <p className="mt-3 font-display text-xs font-bold uppercase tracking-[0.2em] text-[#0A192F]">{m.label}</p>
            {m.note && <p className="mt-2 text-xs leading-relaxed text-[#4A5568]">{m.note}</p>}
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
